import { ref } from 'vue'

import type { ConfigSection } from '../api'

export function createSystemStore(api: {
  list: () => Promise<{ sections: ConfigSection[] }>
}) {
  const sections = ref<ConfigSection[]>([])
  const loading = ref(false)
  const error = ref('')

  async function load() {
    loading.value = true
    error.value = ''
    try {
      const result = await api.list()
      sections.value = result.sections
    } catch (e: any) {
      error.value = e?.message || String(e)
      throw e
    } finally {
      loading.value = false
    }
  }

  function sectionById(id: string): ConfigSection | undefined {
    return sections.value.find(section => section.id === id)
  }

  return { sections, loading, error, load, sectionById }
}
